// This file is generated by pnpm icons:generate. Do not edit.

import {createSVG} from '../TEMPLATE'

export const PaintBucket = createSVG({
  elements: [
    {
      fill: 'currentColor',
      stroke: 'none',
      type: 'path',
      d: 'M21.987 13.038a.75.75 0 0 0 .294-1.241L11.453.969a.75.75 0 0 0-1.06 0L6.586 4.781 4.28 2.47a.75.75 0 0 0-1.06 1.062l2.306 2.306-4.12 4.116a2.25 2.25 0 0 0 0 3.182l7.959 7.959a2.25 2.25 0 0 0 3.182 0l7.358-7.359Zm-3.018-.491-7.484 7.484a.75.75 0 0 1-1.06 0l-7.956-7.956a.75.75 0 0 1 0-1.06l4.117-4.118 2.73 2.73a2.625 2.625 0 1 0 1.06-1.061l-2.729-2.73 3.281-3.276L20.362 12l-1.1.366a.76.76 0 0 0-.293.18Zm-8.14-2.467h0a1.243 1.243 0 1 1-.005.006s.005-.005.005-.006Zm11.545 5.25a.75.75 0 0 0-1.248 0c-.166.254-1.626 2.49-1.626 4.17a2.25 2.25 0 0 0 4.5 0c0-1.68-1.46-3.916-1.626-4.166Zm-.624 4.92a.75.75 0 0 1-.75-.75c0-.637.375-1.53.75-2.257.375.727.75 1.625.75 2.257a.75.75 0 0 1-.75.75Z',
      fillRule: 'evenodd',
    },
  ],
  viewBox: '0 0 24 24',
  glyph: 'PaintBucket',
})
